import {
	PropsWithChildren,
	ReactElement,
	RefObject,
	useCallback,
	useRef
} from "react";
import classNames from "classnames";
import { useResizeObserver } from "client/Hooks";
import styles from "./AlertBarAnimator.module.less";

export type AlertBarAnimatorProps = {
	isBeingRemoved: boolean;
	onRemoved(): void;
};

export const AlertBarAnimator = (props: PropsWithChildren<AlertBarAnimatorProps>): ReactElement => {
	const {
		isBeingRemoved,
		onRemoved,
		children
	} = props;

	const contentRef: RefObject<HTMLDivElement | null> = useRef<HTMLDivElement>(null);
	const {
		height: contentHeight,
		wasInitialized: wasContentHeightInitialized
	} = useResizeObserver(contentRef);

	const onAnimationEnd = useCallback(
		(args: React.AnimationEvent<HTMLDivElement>): void => {
			if (isBeingRemoved && args.animationName === styles.rootFadeOutKeyFrames) {
				onRemoved();
			}
		},
		[isBeingRemoved, onRemoved]
	);

	return (
		<div
			className={classNames(
				styles.root,
				{
					[styles.root_fadeIn]: Boolean(contentHeight),
					[styles.root_fadeOut]: isBeingRemoved
				}
			)}
			style={{
				height: contentHeight,
				opacity: wasContentHeightInitialized ? undefined : 0
			}}
			onAnimationEnd={onAnimationEnd}
		>
			<div className={styles.content} ref={contentRef}>
				{ children }
			</div>
		</div>
	);
};
AlertBarAnimator.displayName = "AlertBarAnimator";
